import { render, staticRenderFns } from "./TheSearchSetup.vue?vue&type=template&id=6230f784&"
import script from "./TheSearchSetup.vue?vue&type=script&lang=js&"
export * from "./TheSearchSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports